export const EquipmentNameList = [
  { id: "bac", name: "Bac" },
  { id: "borne", name: "Borne" },
];

export const EquipmentNameListLabels: Record<string, string> =
  EquipmentNameList.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {});
